import { ReactComponent as Logo } from '../assets/logo.svg';
import React from 'react';

export const Footer = React.memo(() => {
    return (
        <footer>
            <div className="pt-10 pb-24 md:pt-10 lg:pt-10 bg-primary">
                <div
                    className="container flex justify-between"
                    role="contentinfo">
                    <Logo className="h-auto icon-white w-logo" />
                </div>
            </div>
        </footer>
    );
});
